import { default as WorldBlue } from './WorldBlue.svg?react';
import { default as YellowFlaim } from './YellowFlaim.svg?react';
import { default as CompleteCheck } from './CompleteCheck.svg?react';
import { default as EmailAt } from './EmailAt.svg?react';
import { default as RedCircleCheck } from './RedCircleCheck.svg?react';
import { default as GreenCircleCheck } from './GreenCircleCheck.svg?react';
import { default as RedTriangle } from './RedTriangle.svg?react';
import { default as EditIcon } from './EditIcon.svg?react';
import { default as DeleteIcon } from './DeleteIcon.svg?react';
import { default as ConnectAccountIcon } from './ConnectAccountIcon.svg?react';
import { default as CustomSmtpIcon } from './CustomSmtpIcon.svg?react';
import { default as DownloadCsvIcon } from './DownloadCsvIcon.svg?react';
import { default as ExcelIcon } from './excelIcon.svg?react';
import { default as FileUploadIcon } from './FileUploadIcon.svg?react';
import { default as FindDomainIcon } from './FindDomainIcon.svg?react';
import { default as GmailIcon } from './GmailIcon.svg?react';
import { default as OutlookIcon } from './OutlookIcon.svg?react';
import { default as RefreshIcon } from './RefreshIcon.svg?react';
import { default as PauseIcon } from './PauseIcon.svg?react';
import { default as DisableIcon } from './StopIcon.svg?react';
import { default as StreamlineWeb } from './StreamlineWeb.svg?react';
import { default as TablerExternalLink } from './TablerExternalLink.svg?react';
import { default as WarningIconBlack } from './WarningIconBlack.svg?react';
import { default as SearchIcon } from './SearchIcon.svg?react';
import { default as InfoIcon } from './InfoIcon.svg?react';


const ICONS = {
    WorldBlue,
    YellowFlaim,
    CompleteCheck,
    EmailAt,
    RedCircleCheck,
    GreenCircleCheck,
    RedTriangle,
    EditIcon,
    DeleteIcon,
    ConnectAccountIcon,
    CustomSmtpIcon,
    DownloadCsvIcon,
    ExcelIcon,
    FileUploadIcon,
    FindDomainIcon,
    GmailIcon,
    OutlookIcon,
    RefreshIcon,
    PauseIcon,
    DisableIcon,
    StreamlineWeb,
    TablerExternalLink,
    WarningIconBlack,
    SearchIcon,
    InfoIcon
}

export default ICONS;